import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material'
import React from 'react'
import { listConversations } from './util'
import { type ConversationMetadata } from './model'
import { formatDistanceToNow } from 'date-fns'

export default function ListConversations (): JSX.Element {
  const [rows, setRows] = React.useState<ConversationMetadata[]>([])
  const [loaded, setLoaded] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')

  // todo
  React.useEffect(() => {
    listConversations().then((response) => {
      setRows(response.conversations)
    }).catch((error) => {
      setHasError(true)
      setErrorMessage(error.toString() as string)
    }).finally(() => {
      setLoaded(true)
    })
  }, [])

  if (!loaded) {
    return (<div>Loading...</div>)
  } else if (hasError) {
    return (<div>{errorMessage}</div>)
  }
  return (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Creation Date</TableCell>
              <TableCell>Message Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, key) => (
              <TableRow
                key={key}
              >
                <TableCell component="th" scope="row">
                  <a href={`/#/chat?conversationId=${row.conversationId}`}>{row.conversationId}</a>
                </TableCell>
                <TableCell>{`${formatDistanceToNow(new Date(row.creationDate))} ago`}</TableCell>
                <TableCell>{row.messageCount}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
  )
}
